export default "__VITE_ASSET__ffa1af65__"